import { z } from 'zod';

export const signInSchema = z.object({
  email: z
    .string({ message: 'Email is required' })
    .min(1, { message: 'Email is required' })
    .pipe(
      z.email({ message: 'Please enter a valid email address' })
    ),
  password: z
    .string({ message: 'Password is required' })
    .min(1, { message: 'Password is required' })
    .min(6, { message: 'Password must be at least 6 characters long' }),
});

export type SignInFormData = z.infer<typeof signInSchema>;